export default __webpack_public_path__ + "static/media/hardwareMode.d828b61d.svg";